import React from 'react'
import config from '../../config.json'
import Page from '../page/Page'
import SearchComponent from '../searchitems/'
import { BreadcrumbItem, Breadcrumbs } from '@nextui-org/react'

const Auctions = (props) => {
    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null
    const preview = collectionDetails ? collectionDetails['preview'] : null

    return (
        <Page
            id={'AuctionsPage'}
            title={config.titles.auction.replace(
                '{collectionName}',
                collectionName ? 'for ' + collectionName : '',
            )}
            description={config.descriptions.auction.replace(
                '{collectionName}',
                collectionName ? collectionName + ', ' : '',
            )}
            image={preview}
            banners={false}
            {...props}
            pageTitle={'Exclusive NFT Auction'}
            pageSubtitle={'Bid Now for Unique Digital Assets!'}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Auctions',
                    link: '/auctions',
                },
            ]}
        >
            <SearchComponent
                {...props}
                searchSettings={{
                    owner: '',
                    search_type: {
                        value: 'auctions',
                        fixed: false,
                    },
                    order_by: { value: 'end_asc', fixed: false },
                    minimal: false,
                    tab: 'auctions',
                    searchOfferType: 'auctions',
                    page_component: false,
                    limit: { value: 40, fixed: true },
                    expanded: false,
                }}
                limit={40}
                tab={'auctions'}
            />
        </Page>
    )
}

export default Auctions
